import { useEffect, useState } from 'react'

type WindowSizeType = {
  isLargeDesktop: boolean
  isDesktop: boolean
  isSmallDesktop: boolean
  isTablet: boolean
  isMobile: boolean
  width: number
  height: number
}

export function useWindowSize(): WindowSizeType {
  const [windowSize, setWindowSize] = useState<WindowSizeType>(getValues())

  function getValues() {
    const { innerWidth: width, innerHeight: height } = window
    const isLargeDesktop = width > 1799
    const isDesktop = !isLargeDesktop && width > 1439
    const isSmallDesktop = !isLargeDesktop && !isDesktop && width > 959
    const isTablet =
      !isLargeDesktop && !isDesktop && !isSmallDesktop && width > 719
    const isMobile =
      !isLargeDesktop && !isDesktop && !isSmallDesktop && !isTablet
    return {
      isLargeDesktop,
      isDesktop,
      isSmallDesktop,
      isTablet,
      isMobile,
      width,
      height,
    }
  }

  useEffect(() => {
    function handleResize() {
      setWindowSize(getValues())
    }

    window.addEventListener('resize', handleResize)

    handleResize()

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowSize
}
